/**
 * Enum of searchable fields in the Insights screen
 */
export enum SearchableField {
  Name = 'name',
  PrimaryText = 'primaryText',
  AdId = 'externalId',
  LabelName = 'labelName',
  AdLabel = 'adLabel',
  CampaignName = 'campaignName',
  CampaignId = 'campaignId',
  AdSetId = 'adSetId',
  AdSetName = 'adSetName',
  Tag = 'tag',
  HookText = 'hookText',
  Headline = 'headline',
  DominantColor = 'dominantColor',
}
